import instance from '../../axios/ctdentAxios';

import {
	CTDENT_PARTNER_GET_DRAFT_REPORT,
	CTDENT_PARTNER_SAVE_DRAFT_REPORT,
	CTDENT_PARTNER_DELETE_DRAFT_REPORT,
	CTDENT_PARTNER_REQUEST_FOR_REVIEW,
	CTDENT_PARTNER_LIST,
	CTDENT_PARTNER_EXTERNAL_DETAIL,
	CTDENT_PARTNER_EXTERNAL_FILE_DETAIL,
} from '../../assets/conf/api-endpoints';

import { apiConfig } from '../common.service';

export async function savePartnerDraftReport(requestParam, signal) {
	const reqConfig = apiConfig();
	return await instance.post(
		CTDENT_PARTNER_SAVE_DRAFT_REPORT,
		requestParam,
		{ ...reqConfig, signal },
	);
}

export async function getPartnerDraftReport(requestParam) {
	const reqConfig = apiConfig();
	return await instance.post(
		CTDENT_PARTNER_GET_DRAFT_REPORT,
		requestParam,
		reqConfig,
	);
}

export async function partnerRequestForReview(requestParam) {
	const reqConfig = apiConfig();
	return await instance.post(
		CTDENT_PARTNER_REQUEST_FOR_REVIEW,
		requestParam,
		reqConfig,
	);
}

export async function deletePartnerDraftReport(appointmentId) {
	const reqConfig = apiConfig();
	return await instance.delete(
		`${CTDENT_PARTNER_DELETE_DRAFT_REPORT}/${appointmentId}`,
		reqConfig,
	);
}

export async function getPartners() {
	const reqConfig = apiConfig();
	return await instance.get(CTDENT_PARTNER_LIST, {
		headers: reqConfig?.headers,
		method: reqConfig?.method,
	});
}

export async function getPartnerExternalDetail(id) {
	const reqConfig = apiConfig();
	return await instance.get(`${CTDENT_PARTNER_EXTERNAL_DETAIL}${id}`, {
		headers: reqConfig?.headers,
		method: reqConfig?.method,
	});
}

export async function getPartnerExternalFileDetail(examination, file) {
	const reqConfig = apiConfig();
	return await instance.post(
		CTDENT_PARTNER_EXTERNAL_FILE_DETAIL,
		{ examination, file },
		reqConfig,
	);
}
